export const fetchAreasListUrl = `/areas`;
export const fetchAreasCreateUrl = `/areas`;
export const fetchAreasInfoUrl = `/areas`;
export const fetchAreasCancelUrl = `/areas`;
export const fetchAreasEditUrl = `/areas`;
